// extracted by mini-css-extract-plugin
module.exports = {"litresWidget":"LitresWidget_litresWidget__M2ic_","litresWidget__title":"LitresWidget_litresWidget__title__m1FHA"};